<template>
    <div class="title_block h2_desc">
      
        <div class="title_acc" @click="toggleAccordion">
            <h2 v-show="title" class="mb-0 font-active">{{ title }}</h2>
        <SvgHeaderSvg v-if="active" :type="'up'"/>
        <SvgHeaderSvg v-else :type="'down'"/>
        </div>
        <div v-if="active">
            <p v-show="description" class="mb-0 mt-2" v-html="description"></p>
        </div>
    </div>
</template>

<script setup>
    const { title, description } = defineProps(['title', 'description'])
    const skeleton = ref(false)
    const active = ref(true);

    const toggleAccordion = () => {
    active.value = !active.value;
};
</script>

<style scoped>
.title_acc{
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

h2 {
    font-size: 20px;
    text-align: left;
    text-transform: capitalize;
}

p {
    font-size: 16px;
    text-align: left;
    line-height: 1.5;
    color: #6a6161;
}
.title_block {
    margin: 3% 0 2% 0;
}


@media(max-width:767px){
   .title_block {
        margin: 6% 0;
    }
    h2{
        font-size: 18px;
    }
    p{
        font-size: 14px;
    }
}
</style>
